import { render, staticRenderFns } from "./owners_club_lp.vue?vue&type=template&id=4185d874&"
import script from "./owners_club_lp.vue?vue&type=script&lang=js&"
export * from "./owners_club_lp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports